import type { ResolvedFeatureDto } from '@/src/types/featureExperience'

/**
 * Cutover / forced phase: everyone on next; server will not honor classic preference.
 * Prefer this over ad-hoc checks — aligns with `forceVersion`, `phase === 'forced'`, and `reason === 'forced'`.
 */
export function isResolvedForced(feature: ResolvedFeatureDto | undefined): boolean {
  if (!feature) {
    return false
  }

  if (feature.forceVersion) {
    return true
  }

  if (feature.phase === 'forced') {
    return true
  }

  return feature.reason === 'forced'
}
